export default "<aff-dashboard-header> </aff-dashboard-header>\n<aff-dashboard-charts> </aff-dashboard-charts>\n<aff-dashboard-tables> </aff-dashboard-tables>"